/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum HttpResponseCodes {
    OK = 200,
    Accepted = 202,
    NoContent = 204,

    Found = 302,

    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404,
    MethodNotAllowed = 405,
    Conflict = 409,
    TooManyRequests = 429,
    NoResponse = 444,
    ClientClosedRequest = 499,

    InternalServerError = 500,
    ServiceUnavailable = 503,
}
